import './e-imzo';
import './e-imzo-client';
import EIMZO from './EIMZO';

export const ReactEIMZO = new EIMZO();